import styled from "styled-components";

const FONT_SIZES = {
  sm: "0.75rem",
  md: "0.875rem",
  lg: "1.25rem",
};

export const NumberBadge = styled.span<{ $size?: "sm" | "md" | "lg" }>`
  font-size: ${(p) => FONT_SIZES[p.$size ?? "sm"]};
  padding: 0.125rem 0.25rem;
  align-self: center;
  margin-left: 0.125rem;
  color: ${(p) => p.theme.text.default};
  background-color: ${(p) => p.theme.badge.background};
  border-radius: 4px;
  white-space: nowrap;
`;
